export const selectEnv = ({env}) => env;

export default initialState => (function reducer() {
  return initialState;
});



// WEBPACK FOOTER //
// ./mobile/shared/reducers/env.js